export function getStartUrlForProvider(provider: string) {
  return `/sso/start?provider=${provider}`;
}
